// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"106":"project-workbench","176":"projects","818":"auth"}[chunkId] || chunkId) + "." + {"26":"fe85b850","106":"3c913666","176":"54b26cae","818":"0a5a8dec","891":"4d9d86fe"}[chunkId] + ".css";
};